import { Reveal, LeafMotif } from "./Reveal";

export default function FinalCta({ onRequest }) {
  return (
    <section data-testid="final-cta-section" className="relative bg-[#132C20] py-20 lg:py-32 overflow-hidden">
      <LeafMotif className="pointer-events-none absolute top-10 left-[6%] w-20 h-20 text-[#C5A059]/15 -rotate-12" />
      <LeafMotif className="pointer-events-none absolute bottom-10 right-[6%] w-24 h-24 text-[#C5A059]/10 rotate-12" />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
        <Reveal>
          <h2 className="font-serif text-3xl sm:text-5xl lg:text-6xl text-[#FAF7F2] tracking-tight leading-tight">
            Your Child's Journey Is Unique.{" "}
            <em className="italic text-transparent bg-clip-text bg-gradient-to-r from-[#C5A059] via-[#D4AF37] to-[#9E7B3B]">
              Their Care Can Be Personalized Too.
            </em>
          </h2>
          <p className="mt-6 text-base text-[#FAF7F2]/70 leading-relaxed max-w-xl mx-auto">
            Meet Dr. Santhisree Bheesetti during her USA visit and explore a personalized Ayurvedic approach designed
            around your child's individual needs.
          </p>
          <button
            data-testid="final-cta-btn"
            onClick={() => onRequest()}
            className="mt-10 bg-[#C5A059] text-[#1B3B2B] font-semibold tracking-wide text-sm px-10 py-4.5 py-4 rounded-full hover:bg-[#D4AF37] transition-all duration-300 hover:-translate-y-0.5 shadow-[0_16px_40px_rgb(197,160,89,0.3)]"
          >
            REQUEST YOUR USA CONSULTATION
          </button>
          <p className="mt-6 text-sm text-[#FAF7F2]/55">
            Not sure which pathway is right for your child?{" "}
            <button
              data-testid="final-cta-talk-link"
              onClick={() => onRequest("Not Sure — Please Guide Me")}
              className="underline underline-offset-4 text-[#C5A059] hover:text-[#D4AF37] transition-colors"
            >
              Talk to our team.
            </button>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
